import { Space, Tag, Tooltip } from 'antd'
import { COLORS } from 'app/constants'
import React from 'react'
import { Text } from 'styles/reactnative'
import { TagWrap } from '../../../components/AdminUserModal/UserInfoTabs/styles'
import EntryTime from '../../../components/PositionColumns/EntryTime'
import KrwPrice from '../../../components/PositionColumns/KrwPrice'
import UserTag from '../../../components/UserTag'
import ActionButton from '../ActionButton'
import BankInput from './BankInput'
import MemoInput from './MemoInput'

export const AdminWithdrawalTableColumn: any = (mutate, openModal) => {
	return [
		{
			title: '번호',
			dataIndex: 'id',
			align: 'center',
			width: 60,
			render: (text, data) => (
				<Text
					style={{
						whiteSpace: 'nowrap',
						overflow: 'hidden',
						textOverflow: 'ellipsis',
						width: 60,
					}}>
					{text}
				</Text>
			),
		},
		{
			title: '생성일',
			dataIndex: 'created_at',
			align: 'center',
			width: 130,
			render: (text, data) => <EntryTime time={text} />,
		},
		{
			title: '인출일',
			dataIndex: 'confirm_at',
			align: 'center',
			width: 130,
			render: (text, data) => {
				{
					return text ? <EntryTime time={text} /> : <Text>-</Text>
				}
			},
		},
		{
			title: '그룹',
			dataIndex: 'referral_code',
			align: 'center',
			render: (text, data) => <Text>{text}</Text>,
		},
		{
			title: '회원',
			dataIndex: 'user_id',
			align: 'center',
			width: 150,
			render: (text, data) => (
				<UserTag
					userid={data?.user_id}
					email={data?.email}
					phone={data?.phone}
					nickname={data?.fullname || data?.nickname}
					onClick={() => {
						openModal(data?.user_id)
					}}
				/>
			),
		},
		{
			title: '아이디',
			dataIndex: 'loginid',
			align: 'center',
			render: (text, data) => <Text>{text}</Text>,
		},
		{
			title: '진행',
			dataIndex: 'process',
			align: 'center',
			width: 50,
			render: (text, data) => (
				<TagWrap>
					{text == 1 ? (
						<Tag
							style={{
								backgroundColor: '#f79336',
								color: 'white',
							}}>
							대기
						</Tag>
					) : text == 2 ? (
						<Tag
							style={{
								backgroundColor: COLORS.lightGreen,
								color: 'white',
							}}>
							{data?.confirm_amount ? '출금완료' : '출금승인'}
						</Tag>
					) : text == 3 ? (
						<Tag
							style={{ backgroundColor: '#444', color: 'white' }}>
							출금대기
						</Tag>
					) : text == 4 ? (
						<Tag style={{ color: 'red' }}>거절됨</Tag>
					) : (
						<Tag>취소</Tag>
					)}
				</TagWrap>
			),
		},
		{
			title: '출금신청액',
			align: 'center',
			dataIndex: 'amount',
			render: (text, data) => <KrwPrice price={text} dp={0} />,
		},
		{
			title: '출금승인액',
			align: 'center',
			dataIndex: 'confirm_amount',
			render: (text, data) => <KrwPrice price={text || 0} dp={0} />,
		},
		{
			title: '출금계좌',
			align: 'center',
			dataIndex: 'bankaccount',
			render: (text, data) => {
				return <BankInput data={data} type={'W'} mutate={mutate} />
			},
		},
		{
			title: '출금메모',
			align: 'center',
			dataIndex: 'memo',
			render: (text, data) => (
				<MemoInput data={data} type={'W'} mutate={mutate} />
			),
		},
		{
			title: '회원메모',
			align: 'center',
			width: 150,
			dataIndex: 'usermemo',
			render: (text, data) => (
				<Tooltip title={data?.usermemo}>
					<Text
						style={{
							whiteSpace: 'nowrap',
							overflow: 'hidden',
							justifyContent: 'flex-start',
							textOverflow: 'ellipsis',
							width: 130,
							fontSize: 12,
						}}>
						{data?.usermemo || '-'}
					</Text>
				</Tooltip>
			),
		},
		{
			title: '관리',
			align: 'center',
			dataIndex: 'action',
			render: (text, data) => (
				<Space.Compact direction="horizontal">
					{data?.process != 2 ? (
						<>
							{data?.process != 3 && data?.process != 4 && (
								<ActionButton
									title={'검토'}
									process={3}
									type={'W'}
									mutate={mutate}
									id={data?.id}
								/>
							)}

							{data?.process != 2 && data?.process != 4 && (
								<ActionButton
									title={'승인'}
									process={9}
									price={data?.amount}
									type={data?.type}
									mutate={mutate}
									id={data?.id}
								/>
							)}
							{data?.process != 4 && (
								<ActionButton
									title={'거절'}
									process={4}
									type={'W'}
									mutate={mutate}
									id={data?.id}
								/>
							)}
						</>
					) : (
						<>
							{!data?.confirm_amount && (
								<ActionButton
									title={'인출'}
									process={9}
									price={data?.amount}
									type={data?.type}
									mutate={mutate}
									id={data?.id}
								/>
							)}
						</>
					)}
				</Space.Compact>
			),
		},
	]
}
